import { useEffect, useState } from 'react';

interface TypewriterTextProps {
  words: string[];
  delay?: number;
  className?: string;
  typingDelay?: number;
  deletingDelay?: number;
  pauseDelay?: number;
}

export function TypewriterText({ 
  words, 
  typingDelay = 50, 
  deletingDelay = 30,
  pauseDelay = 2000,
  className = '' 
}: TypewriterTextProps) {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const currentWord = words[wordIndex];

    if (!isDeleting && currentIndex < currentWord.length) {
      // Typing
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + currentWord[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, typingDelay);
      return () => clearTimeout(timeout);
    } 
    else if (!isDeleting && currentIndex === currentWord.length) {
      // Pause before deleting
      const timeout = setTimeout(() => {
        setIsDeleting(true);
      }, pauseDelay);
      return () => clearTimeout(timeout);
    }
    else if (isDeleting && currentIndex > 0) {
      // Deleting
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev.slice(0, -1));
        setCurrentIndex(prev => prev - 1);
      }, deletingDelay);
      return () => clearTimeout(timeout);
    }
    else if (isDeleting && currentIndex === 0) {
      // Move to next word
      setIsDeleting(false);
      setWordIndex(prev => (prev + 1) % words.length);
    }
  }, [currentIndex, isDeleting, wordIndex, words, typingDelay, deletingDelay, pauseDelay]);

  return (
    <span className={className}>
      {displayText}
      <span className="animate-pulse">|</span>
    </span>
  );
}